<div class="empty-course-lst">
  <img
    class="empty-course-lst__image"
    src="/public/logos/valvur.svg"
    alt="Empty courses"
  />

  <div class="empty-course-lst__content">
    <div class="empty-course-lst__title">
      {{ 'app.components.emptyCourseList.title' | translate }}
    </div>
    <div *ngIf="showButton()" class="empty-course-lst__description">
      {{ 'app.components.emptyCourseList.description' | translate }}
    </div>
  </div>

  @if (showButton()) {
    <app-cta-button variant="light" size="small" (click)="onButtonClick()">
      <img cta-prefix src="/public/svgs/plus-rounded.svg" alt="Plus" />
      <span cta-label>{{ 'app.components.studiesAll.new' | translate }}</span>
    </app-cta-button>
  }
</div>
